// Common timezones with their UTC offsets
export const timezones = [
  { label: 'Local Time', value: 'local', offset: 0 },
  { label: 'UTC / GMT', value: 'UTC', offset: 0 },
  { label: 'Vienna, Austria (CET/CEST)', value: 'Europe/Vienna', offset: 1 },
  { label: 'London (GMT/BST)', value: 'Europe/London', offset: 0 },
  { label: 'Paris (CET/CEST)', value: 'Europe/Paris', offset: 1 },
  { label: 'Berlin (CET/CEST)', value: 'Europe/Berlin', offset: 1 },
  { label: 'Amsterdam (CET/CEST)', value: 'Europe/Amsterdam', offset: 1 },
  { label: 'Barcelona (CET/CEST)', value: 'Europe/Madrid', offset: 1 },
  { label: 'Rome (CET/CEST)', value: 'Europe/Rome', offset: 1 },
  { label: 'Dubai (GST)', value: 'Asia/Dubai', offset: 4 },
  { label: 'Tehran (IRST)', value: 'Asia/Tehran', offset: 3.5 },
  { label: 'Tokyo (JST)', value: 'Asia/Tokyo', offset: 9 },
  { label: 'Sydney (AEDT/AEST)', value: 'Australia/Sydney', offset: 11 },
  { label: 'New York (EST/EDT)', value: 'America/New_York', offset: -5 },
  { label: 'Los Angeles (PST/PDT)', value: 'America/Los_Angeles', offset: -8 },
  { label: 'Singapore (SGT)', value: 'Asia/Singapore', offset: 8 },
  { label: 'Hong Kong (HKT)', value: 'Asia/Hong_Kong', offset: 8 },
  { label: 'Bangkok (ICT)', value: 'Asia/Bangkok', offset: 7 },
  { label: 'Moscow (MSK)', value: 'Europe/Moscow', offset: 3 },
  { label: 'Istanbul (EET)', value: 'Europe/Istanbul', offset: 3 },
  { label: 'Mumbai (IST)', value: 'Asia/Kolkata', offset: 5.5 },
  { label: 'São Paulo (BRT/BRST)', value: 'America/Sao_Paulo', offset: -3 },
  { label: 'Mexico City (CST/CDT)', value: 'America/Mexico_City', offset: -6 },
  { label: 'Toronto (EST/EDT)', value: 'America/Toronto', offset: -5 },
]

export function formatTimeInTimezone(timezone: string): string {
  if (timezone === 'local') {
    return new Date().toLocaleTimeString('fa-IR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
  }

  try {
    const formatter = new Intl.DateTimeFormat('fa-IR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: timezone,
    })
    return formatter.format(new Date())
  } catch (error) {
    console.error(`Invalid timezone: ${timezone}`, error)
    return 'N/A'
  }
}

export function getTimezoneLabel(timezone: string): string {
  const tz = timezones.find(t => t.value === timezone)
  return tz ? tz.label : timezone
}
